(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kr-sale-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kr-sale-countdown')) {
customElements.define('kr-sale-countdown', class extends HTMLElement {
connectedCallback() {
window.clearInterval(this.interval);
this.hidden=false;
this.setupSticky();
if(this.dataset.showTimer!=='true') return;
this.timer=this.querySelector('.kr-sale__timer');
this.expired=this.querySelector('.kr-sale__expired');
this.units=Object.fromEntries(Array.from(this.querySelectorAll('[data-unit]'),el=>[el.dataset.unit,el]));
if(this.dataset.mode==='duration') {
const number=key=>Math.min(365000,Math.max(0,Math.floor(Number(this.dataset[key])||0)));
const duration=(number('days')*86400+number('hours')*3600+number('minutes')*60+number('seconds'))*1000;
if(duration<=0) {this.timer.hidden=true;return;}
const signature=String(duration);
const storageKey='kr-countdown:'+this.dataset.section;
let startedAt=Date.now();
try {
const stored=JSON.parse(localStorage.getItem(storageKey)||'null');
let matches=stored && stored.signature===signature;
if(stored && !matches){
const previous=JSON.parse(stored.signature);
matches=Array.isArray(previous) && previous[0]===duration && previous[1]===false;
}
if(matches && Number.isFinite(stored.startedAt) && stored.startedAt<=Date.now())startedAt=stored.startedAt;
localStorage.setItem(storageKey,JSON.stringify({signature,startedAt}));
} catch {}
this.deadline=startedAt+duration;
} else {
const input=(this.dataset.end||'').trim();
const validFormat=/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(input);
this.deadline=validFormat?Date.parse(input):NaN;
if(!Number.isFinite(this.deadline)){this.timer.hidden=true;return;}
}
this.expired.hidden=true;
if(this.tick())this.interval=window.setInterval(()=>this.tick(),1000);
}
disconnectedCallback(){window.clearInterval(this.interval);this.cleanupSticky();}
tick(){
const total=Math.max(0,Math.ceil((this.deadline-Date.now())/1000));
const values={days:Math.floor(total/86400),hours:this.units.days?Math.floor(total/3600)%24:Math.floor(total/3600),minutes:Math.floor(total/60)%60,seconds:total%60};
for(const [key,element] of Object.entries(this.units))element.textContent=String(values[key]).padStart(2,'0');
if(total>0){this.timer.hidden=false;this.expired.hidden=true;return true;}
window.clearInterval(this.interval);
if(this.dataset.hideExpired==='true' && this.dataset.editor!=='true'){this.hidden=true;this.updateSticky();}
else {this.timer.hidden=true;this.expired.hidden=false;}
return false;
}
setupSticky(){
this.cleanupSticky();
if(this.dataset.sticky!=='true')return;
this.wrapper=this.closest('.shopify-section')||this.parentElement;
this.spacer=document.createElement('div');
this.spacer.className='kr-sale__spacer';
this.spacer.setAttribute('aria-hidden','true');
this.spacer.hidden=true;
this.before(this.spacer);
this.rootStyle=document.documentElement.style;
this.previousStickyHeight=this.rootStyle.getPropertyValue('--kr-sale-sticky-height');
this.scrollController=new AbortController();
this.scheduleSticky=()=>{
if(this.stickyFrame)return;
this.stickyFrame=requestAnimationFrame(()=>{this.stickyFrame=0;this.updateSticky();});
};
window.addEventListener('scroll',this.scheduleSticky,{passive:true,signal:this.scrollController.signal});
window.addEventListener('resize',this.scheduleSticky,{passive:true,signal:this.scrollController.signal});
this.resizeObserver=new ResizeObserver(this.scheduleSticky);
this.resizeObserver.observe(this);
this.updateSticky();
}
updateSticky(){
if(!this.spacer||!this.wrapper)return;
const stuck=!this.hidden && this.wrapper.getBoundingClientRect().top<0;
if(stuck){
const height=this.getBoundingClientRect().height;
this.spacer.style.height=height+'px';
this.spacer.hidden=false;
this.classList.add('kr-sale--stuck');
const fixedHeight=this.getBoundingClientRect().height;
this.spacer.style.height=fixedHeight+'px';
this.writtenStickyHeight=fixedHeight+'px';
this.rootStyle.setProperty('--kr-sale-sticky-height',this.writtenStickyHeight);
} else {
this.spacer.hidden=true;
this.classList.remove('kr-sale--stuck');
this.restoreStickyHeight();
}
}
restoreStickyHeight(){
if(!this.rootStyle||!this.writtenStickyHeight)return;
if(this.rootStyle.getPropertyValue('--kr-sale-sticky-height')===this.writtenStickyHeight){
if(this.previousStickyHeight)this.rootStyle.setProperty('--kr-sale-sticky-height',this.previousStickyHeight);
else this.rootStyle.removeProperty('--kr-sale-sticky-height');
}
this.writtenStickyHeight=null;
}
cleanupSticky(){
this.scrollController?.abort();
this.resizeObserver?.disconnect();
if(this.stickyFrame)cancelAnimationFrame(this.stickyFrame);
this.stickyFrame=0;
this.spacer?.remove();
this.spacer=null;
this.classList.remove('kr-sale--stuck');
this.restoreStickyHeight();
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
